<script>
export default {
  props: {
    pickerType: {
      type: String,
      default: '',
      require: false,
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    mainLabel: {
      type: String,
      default: '',
    },
    rules: {
      type: Object,
      default: null,
    },
    rulesStart: {
      type: Object,
      default: null,
    },
    rulesEnd: {
      type: Object,
      default: null,
    },
    veeNameStart: {
      type: String,
      default: null,
    },
    veeNameEnd: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      require: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  computed: {
    startDateComputed: {
      get() {
        return this.startDate
      },
      set(value) {
        this.$emit('update:value', {
          date_start: value,
          date_end: this.endDate,
        })
      },
    },
    endDateComputed: {
      get() {
        return this.endDate
      },
      set(value) {
        this.$emit('update:value', {
          date_end: value,
          date_start: this.startDate,
        })
      },
    },
  },
}
</script>

<template>
  <validation-provider
    :rules="{
      endTimeBeyondStatTime: { startDate: startDateComputed },
    }"
  >
    <div class="mb-2">{{ mainLabel }}</div>
    <div id="base-date-ranger-picker" class="d-flex align-items-baseline">
      <BaseDatePicker
        :readonly-input="readonly"
        :disabled="disabled"
        :vee-name="veeNameStart"
        v-bind="$attrs"
        :init-date="startDateComputed"
        :type="pickerType"
        :rules="{
          ...(rules ? rules : {}),
          ...(rulesStart ? rulesStart : {}),
        }"
        @update:date="(v) => (startDateComputed = v)"
      />
      <span class="mx-1">
        ~
      </span>
      <BaseDatePicker
        :readonly-input="readonly"
        :disabled="disabled"
        :vee-name="veeNameEnd"
        v-bind="$attrs"
        :init-date="endDateComputed"
        :type="pickerType"
        :rules="{
          ...(rules ? rules : {}),
          ...(rulesEnd ? rulesEnd : {}),
          endTimeBeyondStatTime: { startDate: startDateComputed },
        }"
        @update:date="(v) => (endDateComputed = v)"
      />
    </div>
  </validation-provider>
</template>

<style lang="scss" scoped>
#base-date-ranger-picker {
  ::v-deep #base-date-picker-wrapper {
    width: 50%;
  }
  ::v-deep .mx-datepicker {
    width: 100%;
  }
}
</style>
